<template>
  <div style="padding: 0px" class="sub-view-1">
    <div class="table-navigation">
      <!-- filter -->
      <div class="filter-pilihan">
        <div @click="openClosePilihanStatus(true)" class="filter">
          <!-- tipe filter -->
          <p>Status :</p>
          <!-- value filter -->
          <span>{{ filterData.status }}</span>
          <!-- icon filter -->
          <svg
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <!-- box pilihan filter -->
        <div
          style="margin-top: 2px; display: none"
          ref="boxPilihanStatus"
          class="box-pilihan"
        >
          <p
            @click="openClosePilihanStatus(false, status)"
            :key="status"
            v-for="status in listStatusReimbursement"
          >
            {{ status }}
            <svg
              v-if="status === filterData.status"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                stroke="#00BA88"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </p>
        </div>
        <!-- end of box pilihan filter -->
      </div>
      <!-- end of filter -->

      <!-- bagian untuk cari tambah dan download -->
      <div class="cari-tambah-download">
        <!-- box pencarian -->
        <div class="cari">
          <svg
            style="margin-right: 8px"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <input
            v-model="filterData.pencarian"
            placeholder="Cari"
            type="text"
            name=""
            id=""
          />
        </div>

        <!-- button tambah -->
        <button @click="openModalInput" class="add">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00003 5.14314V10.8574M5.14289 8.00028H10.8572M15.1429 8.00028C15.1429 11.9452 11.9449 15.1431 8.00003 15.1431C4.05514 15.1431 0.857178 11.9452 0.857178 8.00028C0.857178 4.05539 4.05514 0.857422 8.00003 0.857422C11.9449 0.857422 15.1429 4.05539 15.1429 8.00028Z"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <!-- button download -->
        <button @click="downloadData" class="download">
          <svg
            width="16"
            height="16"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 9.14375V12.0009C13.4286 12.3798 13.278 12.7431 13.0101 13.011C12.7422 13.279 12.3789 13.4295 12 13.4295H1.99998C1.6211 13.4295 1.25774 13.279 0.98983 13.011C0.721921 12.7431 0.571411 12.3798 0.571411 12.0009V9.14375M3.42855 5.57227L6.99998 9.14369M6.99998 9.14369L10.5714 5.57227M6.99998 9.14369V0.572266"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <!-- open menu mobile -->
        <div class="open-menu-mobile">
          <!-- menu icon -->
          <svg
            @click="openCloseMenuMobile(true)"
            width="14"
            height="4"
            viewBox="0 0 14 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of menu icon -->

          <div
            style="display: none"
            ref="box-pilihan-menu"
            class="box-pilihan-aksi"
          >
            <!-- buka menu filter -->
            <p @click="openCloseFilterMobile(true)">
              <svg
                width="17"
                height="15"
                viewBox="0 0 17 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.2437 0.571289H1.04053L7.12179 7.32843V12.7141L10.1624 14.1427V7.32843L16.2437 0.571289Z"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Filter
            </p>
            <!-- tambah reimburstsement -->
            <p @click="openModalInput">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00003 5.14265V10.8569M5.14289 7.99979H10.8572M15.1429 7.99979C15.1429 11.9447 11.9449 15.1426 8.00003 15.1426C4.05514 15.1426 0.857178 11.9447 0.857178 7.99979C0.857178 4.0549 4.05514 0.856934 8.00003 0.856934C11.9449 0.856934 15.1429 4.0549 15.1429 7.99979Z"
                  stroke="#FFB700"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Tambah
            </p>

            <!-- melakukan downlaod -->
            <p @click="downloadData">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4287 9.14277V11.9999C13.4287 12.3788 13.2782 12.7422 13.0103 13.0101C12.7423 13.278 12.379 13.4285 12.0001 13.4285H2.0001C1.62122 13.4285 1.25786 13.278 0.989952 13.0101C0.722043 12.7422 0.571533 12.3788 0.571533 11.9999V9.14277M3.42868 5.57129L7.0001 9.14272M7.0001 9.14272L10.5715 5.57129M7.0001 9.14272V0.571289"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Download
            </p>
          </div>
        </div>
        <!-- end of open menu mobile -->
      </div>
    </div>
    <!-- end of bagian untuk cari tambah dan download -->

    <!-- filter mobile -->
    <div style="bottom: -100%" ref="filter-mobile" class="backdrop">
      <div class="filter-mobile">
        <div class="filter-mobile-title">
          <h5>
            Filter <br />
            Reimbursement
          </h5>
          <!-- close filter -->
          <svg
            @click="openCloseFilterMobile(false)"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
              stroke="#1A1A1A"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <!-- input status -->
        <div class="keterangan input-keterangan">
          <div
            @click="openClosePilihanStatusMobile(true)"
            ref="keterangan-form"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterData.status"
                style="display: block"
                class="input-title"
                >Status</span
              >
              <p>
                {{ filterData.status ? filterData.status : "Status" }}
              </p>
            </div>
          </div>
          <!-- box pilihan status -->
          <div
            style="display: none"
            ref="boxPilihanStatusMobile"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanStatusMobile(false, status)"
              v-for="status in listStatusReimbursement"
              :key="status"
            >
              {{ status }}
              <svg
                v-if="status === filterData.status"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan status -->
        </div>

        <!-- end of input status -->

        <div class="button-container">
          <button @click="openCloseFilterMobile(false)" class="yellow-button">
            Terapkan
          </button>
        </div>
      </div>
    </div>
    <!-- end of filter mobile -->

    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th>Waktu Lapor</th>
          <th>Nama Karyawan</th>
          <th style="width: 20%">Deskripsi Belanja</th>
          <th>Nominal</th>
          <th>Lampiran</th>
          <th>Finance Review</th>
        </tr>
        <!-- start iterasi tabel -->
        <tr
          :key="reimbursement.tanggalPengajuan.seconds"
          v-for="reimbursement in filteredReimbursement"
        >
          <!-- waktu lapor  -->
          <td>
            {{ toDate(reimbursement.tanggalPengajuan.seconds) }} <br />
            {{ toClock(reimbursement.tanggalPengajuan.seconds) }}
          </td>
          <!-- Nama Karyawan  -->
          <td>
            <span style="font-weight: 600">{{ userData.nama }}</span>
            <br />
            {{ userData.divisi }} - {{ userData.penempatan }}
          </td>
          <td>
            <!-- kategori -->
            <span style="color: #1d1d1d; font-weight: 700">{{
              reimbursement.kategori
            }}</span>
            <br />
            <!-- deskripsi belanja -->
            <span style="font-size: 12px">{{
              reimbursement.deskripsiBelanja
            }}</span>
          </td>
          <!-- Nominal  -->
          <td>
            Rp{{ formattedNumber(reimbursement.nominal) }} <br />
            {{ reimbursement.jenisTransaksi }}
          </td>
          <td class="tabel-lampiran">
            <!-- lampiran  -->
            <p
              @click="openCloseModalViewer(true, reimbursement.lampiranUrl[0])"
            >
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.42862 0.857422H2.71434C2.33546 0.857422 1.97209 1.00793 1.70419 1.27584C1.43628 1.54375 1.28577 1.90711 1.28577 2.28599V13.7146C1.28577 14.0934 1.43628 14.4568 1.70419 14.7247C1.97209 14.9926 2.33546 15.1431 2.71434 15.1431H11.2858C11.6646 15.1431 12.028 14.9926 12.2959 14.7247C12.5638 14.4568 12.7143 14.0934 12.7143 13.7146V5.14314M8.42862 0.857422L12.7143 5.14314M8.42862 0.857422V5.14314H12.7143M9.85719 8.71456H4.14291M9.85719 11.5717H4.14291M5.57148 5.85742H4.14291"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <span>Dokumen</span>
            </p>
          </td>
          <!-- hasil review finance -->
          <td
            v-if="reimbursement.status === 'rejected'"
            class="hasil-review-tolak"
          >
            <p class="detail-review">
              <span>TOLAK</span>
              {{ toClock(reimbursement.reviewTimestamp.seconds) }}
            </p>
            <p>oleh {{ reimbursement.reviewer }}</p>
          </td>

          <td
            v-else-if="reimbursement.status === 'accepted'"
            class="hasil-review-acc"
          >
            <p class="detail-review">
              <span>ACC</span>
              {{ toClock(reimbursement.reviewTimestamp.seconds) }}
            </p>
            <p>oleh {{ reimbursement.reviewer }}</p>
          </td>

          <td
            v-else-if="reimbursement.status === 'processed'"
            class="hasil-review-proses"
          >
            <p class="detail-review"><span>DIPROSES</span></p>
          </td>

          <td v-else class="hasil-review-proses">
            <p class="detail-review"><span>PENDING</span></p>
          </td>
        </tr>
        <!-- end iterasi tabel -->
      </table>
      <p
        v-if="!filteredReimbursement || filteredReimbursement.length === 0"
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>

    <!-- modal -->
    <ModalInput v-if="modalIsOpen">
      <div style="max-width: 730px" class="content">
        <h2>Ajukan Reimbursement</h2>
        <!-- input form -->
        <div class="list-form-modal">
          <!-- Kategori -->
          <div class="keterangan">
            <div
              ref="kategori-form"
              @click="openClosePilihanKategori(true)"
              class="box-form email"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857178 11.5717L8.00003 15.1431L15.1429 11.5717M0.857178 8.00028L8.00003 11.5717L15.1429 8.00028M8.00003 0.857422L0.857178 4.42885L8.00003 8.00028L15.1429 4.42885L8.00003 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="input-and-title">
                <span
                  v-if="ajukanReimbursement.kategori"
                  style="display: block"
                  class="input-title"
                  >Kategori</span
                >

                <p>
                  {{
                    ajukanReimbursement.kategori
                      ? ajukanReimbursement.kategori
                      : "Kategori"
                  }}
                </p>
              </div>
            </div>
            <!-- box pilihan Kategori -->
            <div
              style="display: none"
              ref="boxPilihanKategori"
              class="box-pilihan"
            >
              <p
                :key="kategori"
                v-for="kategori in listKategoriReimbursement"
                @click="openClosePilihanKategori(false, kategori)"
              >
                {{ kategori }}
                <svg
                  v-if="ajukanReimbursement.kategori === kategori"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan Kategori-->
          </div>
          <!-- end of Kategori -->

          <!-- Deskripsi belanja -->
          <div ref="deskripsi-form" class="box-form email">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1" fill="white">
                <path
                  d="M8.00003 15.1431C11.9449 15.1431 15.1429 11.9452 15.1429 8.00028C15.1429 4.05539 11.9449 0.857422 8.00003 0.857422C4.05514 0.857422 0.857178 4.05539 0.857178 8.00028C0.857178 11.9452 4.05514 15.1431 8.00003 15.1431Z"
                />
                <path
                  d="M8.71432 5.14314C8.71432 5.53762 8.39452 5.85742 8.00003 5.85742C7.60555 5.85742 7.28575 5.53762 7.28575 5.14314C7.28575 4.74865 7.60555 4.42885 8.00003 4.42885C8.39452 4.42885 8.71432 4.74865 8.71432 5.14314Z"
                />
              </mask>
              <path
                d="M7.50003 10.8574C7.50003 11.1336 7.72389 11.3574 8.00003 11.3574C8.27618 11.3574 8.50003 11.1336 8.50003 10.8574H7.50003ZM8.50003 8.00028C8.50003 7.72414 8.27618 7.50028 8.00003 7.50028C7.72389 7.50028 7.50003 7.72414 7.50003 8.00028H8.50003ZM8.50003 10.8574V8.00028H7.50003V10.8574H8.50003ZM14.1429 8.00028C14.1429 11.3929 11.3926 14.1431 8.00003 14.1431V16.1431C12.4972 16.1431 16.1429 12.4975 16.1429 8.00028H14.1429ZM8.00003 14.1431C4.60743 14.1431 1.85718 11.3929 1.85718 8.00028H-0.142822C-0.142822 12.4975 3.50286 16.1431 8.00003 16.1431V14.1431ZM1.85718 8.00028C1.85718 4.60767 4.60743 1.85742 8.00003 1.85742V-0.142578C3.50286 -0.142578 -0.142822 3.5031 -0.142822 8.00028H1.85718ZM8.00003 1.85742C11.3926 1.85742 14.1429 4.60767 14.1429 8.00028H16.1429C16.1429 3.5031 12.4972 -0.142578 8.00003 -0.142578V1.85742ZM7.71432 5.14314C7.71432 4.98534 7.84224 4.85742 8.00003 4.85742V6.85742C8.94681 6.85742 9.71432 6.08991 9.71432 5.14314H7.71432ZM8.00003 4.85742C8.15783 4.85742 8.28575 4.98534 8.28575 5.14314H6.28575C6.28575 6.08991 7.05326 6.85742 8.00003 6.85742V4.85742ZM8.28575 5.14314C8.28575 5.30093 8.15783 5.42885 8.00003 5.42885V3.42885C7.05326 3.42885 6.28575 4.19636 6.28575 5.14314H8.28575ZM8.00003 5.42885C7.84224 5.42885 7.71432 5.30093 7.71432 5.14314H9.71432C9.71432 4.19636 8.94681 3.42885 8.00003 3.42885V5.42885Z"
                fill="#A0A3BD"
                mask="url(#path-1-inside-1)"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="ajukanReimbursement.deskripsiBelanja"
                class="input-title"
                >Deskripsi Belanja</span
              >
              <input
                v-model="ajukanReimbursement.deskripsiBelanja"
                class="input-text"
                required
                placeholder="Deskripsi belanja"
                type="text"
              />
            </div>
          </div>
          <!-- end of Deskripsi belanja -->

          <!-- nominal -->
          <div ref="nominal-form" class="box-form email">
            <svg
              width="13"
              height="12"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.30273 5.54883H1.29883V9H0.167969V0.46875H2.99219C3.95312 0.46875 4.69141 0.6875 5.20703 1.125C5.72656 1.5625 5.98633 2.19922 5.98633 3.03516C5.98633 3.56641 5.8418 4.0293 5.55273 4.42383C5.26758 4.81836 4.86914 5.11328 4.35742 5.30859L6.36133 8.92969V9H5.1543L3.30273 5.54883ZM1.29883 4.62891H3.02734C3.58594 4.62891 4.0293 4.48438 4.35742 4.19531C4.68945 3.90625 4.85547 3.51953 4.85547 3.03516C4.85547 2.50781 4.69727 2.10352 4.38086 1.82227C4.06836 1.54102 3.61523 1.39844 3.02148 1.39453H1.29883V4.62891Z"
                fill="#A0A3BD"
              />
              <path
                d="M12.2539 5.90039C12.2539 6.86523 12.0332 7.64258 11.5918 8.23242C11.1504 8.82227 10.5527 9.11719 9.79883 9.11719C9.0293 9.11719 8.42383 8.87305 7.98242 8.38477V11.4375H6.89844V2.66016H7.88867L7.94141 3.36328C8.38281 2.81641 8.99609 2.54297 9.78125 2.54297C10.543 2.54297 11.1445 2.83008 11.5859 3.4043C12.0312 3.97852 12.2539 4.77734 12.2539 5.80078V5.90039ZM11.1699 5.77734C11.1699 5.0625 11.0176 4.49805 10.7129 4.08398C10.4082 3.66992 9.99023 3.46289 9.45898 3.46289C8.80273 3.46289 8.31055 3.75391 7.98242 4.33594V7.36523C8.30664 7.94336 8.80273 8.23242 9.4707 8.23242C9.99023 8.23242 10.4023 8.02734 10.707 7.61719C11.0156 7.20312 11.1699 6.58984 11.1699 5.77734Z"
                fill="#A0A3BD"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="ajukanReimbursement.nominal" class="input-title"
                >Nominal</span
              >
              <input
                v-model="ajukanReimbursement.nominal"
                class="input-text"
                required
                placeholder="Nominal"
                type="number"
              />
            </div>
          </div>
          <!-- end of nominal -->

          <!-- jenis transaksi -->
          <div class="keterangan">
            <div
              ref="jenis-transaksi-form"
              @click="openClosePilihanTransaksi(true)"
              class="box-form email"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857178 11.5717L8.00003 15.1431L15.1429 11.5717M0.857178 8.00028L8.00003 11.5717L15.1429 8.00028M8.00003 0.857422L0.857178 4.42885L8.00003 8.00028L15.1429 4.42885L8.00003 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="input-and-title">
                <span
                  v-if="ajukanReimbursement.jenisTransaksi"
                  style="display: block"
                  class="input-title"
                  >Jenis transaksi</span
                >

                <p>
                  {{
                    ajukanReimbursement.jenisTransaksi
                      ? ajukanReimbursement.jenisTransaksi
                      : "Jenis Transaksi"
                  }}
                </p>
              </div>
            </div>
            <!-- box pilihan transaksi -->
            <div
              style="display: none"
              ref="boxPilihanTransaksi"
              class="box-pilihan"
            >
              <p
                :key="jenisTransaksi"
                v-for="jenisTransaksi in listJenisTransaksi"
                @click="openClosePilihanTransaksi(false, jenisTransaksi)"
              >
                {{ jenisTransaksi }}
                <svg
                  v-if="ajukanReimbursement.jenisTransaksi === jenisTransaksi"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan transaksi -->
          </div>
          <!-- end of jenis transaksi -->

          <!-- lampiran dokumen -->
          <div class="input-lampiran">
            <label ref="lampiran-form" class="box-form email">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4284 9.14369V12.0008C13.4284 12.3797 13.2779 12.7431 13.01 13.011C12.7421 13.2789 12.3787 13.4294 11.9999 13.4294H1.99986C1.62098 13.4294 1.25762 13.2789 0.989708 13.011C0.721799 12.7431 0.571289 12.3797 0.571289 12.0008V9.14369M10.5713 4.14369L6.99986 0.572266M6.99986 0.572266L3.42843 4.14369M6.99986 0.572266V9.14369"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span style="display: none" class="input-title">Lampiran</span>
                <input
                  ref="lampiran-input"
                  @change="processFile($event)"
                  class="input-text"
                  type="file"
                  accept="image/*,.pdf"
                />
                <p>
                  {{
                    ajukanReimbursement.lampiran
                      ? ajukanReimbursement.lampiran.name
                      : "Lampiran.pdf"
                  }}
                </p>
              </div>
            </label>
            <!-- keterangan file -->
            <p style="margin-top: -29px; color: #a0a3bd">
              Format .pdf, .jpg, .jpeg, .png (max: 3.5 MB)
            </p>
          </div>
          <!-- end of lampiran dokumen -->
        </div>
        <!-- end of input form -->
        <hr />
        <button
          :disabled="isProcessing"
          @click="ajukan"
          style="margin: 20px"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-text"> Ajukan</span>
        </button>
      </div>

      <!-- close button -->
      <svg
        @click="closeModalInput"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalInput>
    <!-- end of modal -->

    <!-- modal view lampiran -->
    <ModalViewer v-if="modalViewerIsOpen">
      <div style="text-align: center" class="modal-content-viewer">
        <object
          style="object-fit: cover; margin: 10px 0px"
          :data="urlLampiran"
          width="750"
          height="390"
        ></object>

        <button
          @click="openDokumen"
          style="margin-top: 10px"
          class="yellow-button"
        >
          Buka dokumen
        </button>
      </div>
      <!-- close button -->
      <svg
        @click="openCloseModalViewer(false)"
        style="margin-top: -438px; margin-left: 340px"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalViewer>
    <!-- end of modal view lampiran -->

    <!-- modal berhasil -->
    <ModalBerhasil v-if="modalBerhasilIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65.4526 42.0845V44.0121C65.45 48.5303 63.987 52.9267 61.2817 56.5454C58.5764 60.1642 54.7738 62.8116 50.441 64.0927C46.1082 65.3737 41.4773 65.2199 37.2391 63.6541C33.0009 62.0883 29.3824 59.1944 26.9232 55.4041C24.464 51.6137 23.296 47.13 23.5933 42.6215C23.8906 38.1131 25.6372 33.8215 28.5728 30.3869C31.5084 26.9523 35.4756 24.5586 39.8827 23.5629C44.2899 22.5672 48.9008 23.0227 53.0279 24.8616M65.4526 27.2502L44.5002 48.2236L38.2145 41.9378"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Sukses Tambah Data</h2>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalBerhasil(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalBerhasil>
    <!-- end of modal berhasil -->
  </div>
</template>

<script>
import ModalInput from "@/components/modal/ModalInput";
import { mapState } from "vuex";
import * as soluhaApi from "@/soluhaApi";
import * as soluhafire from "@/soluhafire";
import ModalViewer from "@/components/modal/RelativeModal";
import ModalBerhasil from "@/components/modal/ModalAlert";
import XLSX from "xlsx";

export default {
  components: {
    ModalInput,
    ModalBerhasil,
    ModalViewer,
  },

  data() {
    return {
      isProcessing: false,
      // status modal
      modalViewerIsOpen: false,
      modalIsOpen: false,
      modalBerhasilIsOpen: false,
      // value filter riwayat
      filterData: {
        status: "semua",
        pencarian: "",
      },
      ajukanReimbursement: {
        deskripsiBelanja: "",
        nominal: "",
        kategori: "",
        lampiran: null,
        jenisTransaksi: "",
      },
      // data modal view
      urlLampiran: "",
    };
  },

  methods: {
    // untuk tutup atau buku box pilihan Status
    openClosePilihanStatus(open, value) {
      let box = this.$refs.boxPilihanStatus;
      if (open) {
        box.style.display = "block";
      } else {
        this.filterData.status = value;
        box.style.display = "none";
      }
    },

    openClosePilihanStatusMobile(open, value) {
      let box = this.$refs.boxPilihanStatusMobile;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.status = value;
      }
    },

    // untuk tutup atau buku box pilihan
    openClosePilihanKategori(open, value) {
      let box = this.$refs.boxPilihanKategori;
      if (open) {
        box.style.display = "block";
      } else {
        this.ajukanReimbursement.kategori = value;
        box.style.display = "none";
      }
    },

    // untuk tutup atau buku box pilihan
    openClosePilihanTransaksi(open, value) {
      let box = this.$refs.boxPilihanTransaksi;
      if (open) {
        box.style.display = "block";
      } else {
        this.ajukanReimbursement.jenisTransaksi = value;
        box.style.display = "none";
      }
    },
    // buka modal input
    openModalInput() {
      this.openCloseMenuMobile(false);
      this.modalIsOpen = true;
    },
    // tutup modal input
    closeModalInput() {
      this.modalIsOpen = false;
    },

    // cek perubahan input untuk munculin input title
    inputChanged(event) {
      let title = event.target.previousSibling;
      if (event.target.value.length > 0) title.style.display = "block";
      else title.sstyle.display = "none";
    },

    processFile(event) {
      this.ajukanReimbursement.lampiran = event.target.files[0];
      let title = event.target.previousSibling;
      if (event.target.value.length > 0) title.style.display = "block";
      else title.style.display = "none";
    },

    toDate(time) {
      return soluhaApi.epochToDate(time);
    },

    toClock(time) {
      return soluhafire.epochToClock(time);
    },

    openCloseModalViewer(isOpen, url) {
      if (isOpen) {
        this.urlLampiran = url;
        this.modalViewerIsOpen = true;
      } else {
        this.urlLampiran = "";
        this.modalViewerIsOpen = false;
      }
    },

    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    openCloseFilterMobile(isOpen) {
      this.openCloseMenuMobile(false);
      let box = this.$refs["filter-mobile"];
      if (isOpen) box.style.bottom = "0px";
      else box.style.bottom = "-100%";
    },

    openDokumen() {
      window.open(this.urlLampiran, "_blank");
    },

    checkForm() {
      let valid = true;
      let pengajuanReimbursement = this.ajukanReimbursement;

      if (!pengajuanReimbursement.kategori) {
        this.$refs["kategori-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!pengajuanReimbursement.deskripsiBelanja) {
        this.$refs["deskripsi-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!pengajuanReimbursement.nominal) {
        this.$refs["nominal-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!pengajuanReimbursement.jenisTransaksi) {
        this.$refs["jenis-transaksi-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!pengajuanReimbursement.lampiran) {
        this.$refs["lampiran-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (this.$refs["lampiran-input"].files[0].size >= 3500000) {
        this.$refs["lampiran-form"].classList.add("failed-box-form");
        valid = false;
      }
      return valid;
    },

    // buka atau tutup modal berhasil
    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },

    async ajukan() {
      let check = this.checkForm();
      this.loader(true);
      if (check) {
        await soluhaApi.ajukanReimbursement(
          this.ajukanReimbursement.deskripsiBelanja,
          this.ajukanReimbursement.nominal,
          this.ajukanReimbursement.kategori,
          this.ajukanReimbursement.lampiran,
          this.ajukanReimbursement.jenisTransaksi
        );
        // kembali ke state awal
        this.ajukanReimbursement.deskripsiBelanja = "";
        this.ajukanReimbursement.nominal = "";
        this.ajukanReimbursement.kategori = "";
        this.ajukanReimbursement.lampiran = null;
        this.ajukanReimbursement.jenisTransaksi = "";
        // remove filter
        this.filterData.status = "semua";
        this.filterData.pencarian = "";
        this.loader(false);
        this.closeModalInput();
        this.openCloseModalBerhasil(true);
      } else {
        this.loader(false);
        return;
      }
    },

    downloadData() {
      this.openCloseMenuMobile(false);
      let dataRiwayat = [];
      this.userData.riwayatReimbursement.forEach((reimbursement) => {
        dataRiwayat.push({
          nama: this.userData.nama,
          divisi: `${this.userData.divisi} - ${this.userData.penempatan}`,
          kategori: reimbursement.kategori,
          deskripsi: reimbursement.deskripsiBelanja,
          nominal: reimbursement.nominal,
          jenisTransaksi: reimbursement.jenisTransaksi,
          lampiran: reimbursement.lampiranUrl[0],
          review: reimbursement.status,
        });
      });
      const data = XLSX.utils.json_to_sheet(dataRiwayat);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `data_reimbursement_${this.userData.nama}.xlsx`);
    },

    formattedNumber(num) {
      num = parseInt(num);
      return num.toLocaleString("id-ID");
    },

    loader(isLoading) {
      let textButton = this.$refs["button-text"];
      let spinner = this.$refs["spinner"];
      if (isLoading) {
        textButton.style.display = "none";
        spinner.style.display = "block";
        this.isProcessing = true;
      } else {
        textButton.style.display = "block";
        spinner.style.display = "none";
        this.isProcessing = false;
      }
    },
  },

  computed: {
    ...mapState([
      "listStatusReimbursement",
      "listKategoriReimbursement",
      "listJenisTransaksi",
      "userData",
    ]),

    filteredReimbursement() {
      let riwayatReimbursement = this.userData.riwayatReimbursement;
      let filterStatus = this.filterData.status;
      let filterPencarian = this.filterData.pencarian.toLowerCase();

      if (filterStatus === "semua") filterStatus = "";
      if (riwayatReimbursement) {
        return riwayatReimbursement.filter(function (item) {
          let filtered = true;
          if (filterStatus && filterStatus.length > 0) {
            filtered = item.status == filterStatus;
          }
          if (filtered) {
            if (filterPencarian && filterPencarian.length > 0) {
              filtered = item.kategori.toLowerCase().includes(filterPencarian);
            }
          }
          return filtered;
        });
      }
      return riwayatReimbursement;
    },
  },
};
</script>
